import { createSlice } from '@reduxjs/toolkit';

const getInitialState = () => {
  const returnData = JSON.parse(localStorage.getItem('returnData')) || null;
  const decodedOrderItemIds = JSON.parse(localStorage.getItem('decodedOrderItemIds')) || [];
  const tempReturn = null

  return {
    returnData,
    decodedOrderItemIds, 
    tempReturn,   
  };
};

const returnRequestSlice = createSlice({
  name: 'returnRequest',
  initialState: getInitialState(),
  reducers: {
    setReturnResponse: (state, action) => {
      const returnData = action.payload?.data?.requestReturn?.return;
      const tempReturnData = action.payload?.data?.requestReturn?.return;

      if (!returnData) return;

      const newDecodedIds = returnData?.items?.map((item) => {
        const encodedId = item?.order_item?.id;
        return encodedId ? atob(encodedId) : null;
      }).filter(Boolean); 


      const orderStatus = tempReturnData?.items?.map((item) => {
        const status = item?.status;
        return status;
      }).filter(Boolean); 
      
      const allDecodedIds = Array.from(new Set([...state.decodedOrderItemIds, ...newDecodedIds]));

      state.returnData = returnData;
      state.decodedOrderItemIds = allDecodedIds;
      state.tempReturn = orderStatus;

      
      localStorage.setItem('returnData', JSON.stringify(returnData)); 
      localStorage.setItem('decodedOrderItemIds', JSON.stringify(allDecodedIds));
    },
    clearReturnData: (state) => {
      state.returnData = null;
      state.decodedOrderItemIds = [];
      state.tempReturn = null;
      localStorage.removeItem('returnData');
      localStorage.removeItem('decodedOrderItemIds');
    },
  },
});

export const { setReturnResponse, clearReturnData } = returnRequestSlice.actions;
export default returnRequestSlice.reducer;
